/**
 * @generated SignedSource<<05806552c9045acf62545900e3c902ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BrandMessageStatusEnum = "A" | "S" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BrandMessageTaskDescriptionList_brandMessageTask$data = {
  readonly created: any;
  readonly createdBy: {
    readonly " $fragmentSpreads": FragmentRefs<"UserAvatarText_user">;
  };
  readonly description: string | null;
  readonly id: string;
  readonly isActive: boolean;
  readonly period: number | null;
  readonly query: string;
  readonly startAt: any;
  readonly template: {
    readonly buttons: ReadonlyArray<{
      readonly linkIos: string | null;
      readonly linkMobile: string | null;
      readonly linkType: string;
      readonly name: string;
    }>;
    readonly content: string;
    readonly createTime: any;
    readonly id: string;
    readonly imageLink: string | null;
    readonly imageUrl: string | null;
    readonly parameterNames: ReadonlyArray<string>;
    readonly serviceStatus: BrandMessageStatusEnum;
    readonly templateCode: string;
    readonly templateName: string;
    readonly updateTime: any | null;
  };
  readonly " $fragmentType": "BrandMessageTaskDescriptionList_brandMessageTask";
};
export type BrandMessageTaskDescriptionList_brandMessageTask$key = {
  readonly " $data"?: BrandMessageTaskDescriptionList_brandMessageTask$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrandMessageTaskDescriptionList_brandMessageTask">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrandMessageTaskDescriptionList_brandMessageTask",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "period",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "query",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "createdBy",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserAvatarText_user"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandMessageTemplate",
      "kind": "LinkedField",
      "name": "template",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templateCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templateName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updateTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "parameterNames",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageLink",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BrandMessageButton",
          "kind": "LinkedField",
          "name": "buttons",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "linkMobile",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "linkType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "linkIos",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandMessageTask",
  "abstractKey": null
};
})();

(node as any).hash = "c462e906fecb21e1f122d89b00304075";

export default node;
